import React from 'react';
import { TextField, Toggle } from 'material-ui';
import R from 'ramda';
import Select from 'react-select';
import RateTable from '../rate-tables/rate-table-template-container';
import TravelSalesDatesPicker from './travel-sales-dates-pickers';
import TaxCurrencyCommissionForm from '../rate-forms/tax-currency-commission-form';
import DaysOfWeek from '../days-of-week';
import StayPays from '../staypay';
const propTypes = {
  stayPays: React.PropTypes.array,
  daysOfWeek: React.PropTypes.array,
  isStayPay: React.PropTypes.bool,
  allowCombination: React.PropTypes.bool,
  offerName: React.PropTypes.string,
  bookingCode: React.PropTypes.string,
  validDatesOfSale: React.PropTypes.array,
  validDatesOfTravel: React.PropTypes.array,
  offerDetail: React.PropTypes.string,
  specialConditions: React.PropTypes.string,
  inEdit: React.PropTypes.bool,
  productType: React.PropTypes.string,
  updateFieldValue: React.PropTypes.func,
  updateTableCell: React.PropTypes.func,
  offerType: React.PropTypes.string,
  rate: React.PropTypes.oneOf(['freeOfCharge', 'discount', 'rateAmount', '']),
  rates: React.PropTypes.array,
  nonStandardTemplateType: React.PropTypes.string,
  discountType: React.PropTypes.string,
  amount: React.PropTypes.string,
  style: React.PropTypes.object,
  contractingPeriod: React.PropTypes.object,
  updateDaysOfWeek: React.PropTypes.func,
};
const datesValid = dates => dates.some(R.prop('fromDate'));
const ratesTableNotValid = R.compose(
  R.isEmpty,
  R.reject(R.propOr('', 'notApplicable')),
  R.propOr([], 'rates')
);
const SpecialOfferTableInEdit = props => {
  const {
    updateFieldValue,
    updateTableCell,
  } = props;
  const ratesNotValid = (() => {
    if (props.rate === 'rateAmount') return ratesTableNotValid(props);
    if (props.rate === 'discount') return !(props.amount && props.discountType);
    return false;
  })();
  return (
    <div style={props.style}>
      <div style={{ display: props.isStayPay ? 'none' : 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'center' }}>
        <div style={{ width: '30%' }}> Stay Pay</div>
        <Toggle
          style={{ width: '70%' }}
          toggled={props.isStayPay}
          onToggle={() => {
            updateFieldValue(['isStayPay'], !props.isStayPay);
            updateFieldValue(['validDatesOfSale'], [{ fromDate: new Date().toISOString(), toDate: props.contractingPeriod.endDate }]);
          }}
        />
      </div>
      <div style={{ display: props.isStayPay ? 'none' : 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' }}>
        <div style={{ width: '30%' }}> Offer title<small style={{ color: 'red', display: !props.offerName ? 'block' : 'none' }}> * Required</small></div>
        <TextField
          id="offerName"
          style={{ width: '70%' }}
          value={props.offerName || ''}
          onChange={(_, value) => updateFieldValue(['offerName'], value)}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' }}>
        <div style={{ width: '30%' }}> Booking code<small style={{ color: 'red', display: !props.bookingCode ? 'block' : 'none' }}> * Required</small></div>
        <TextField
          id="bookingCode"
          style={{ width: '70%' }}
          value={props.bookingCode || ''}
          onChange={(_, value) => updateFieldValue(['bookingCode'], value)}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', alignItems: 'baseline' }}>
        <div style={{ width: '30%', position: 'relative', top: '-12px' }}> Sale dates<small style={{ color: 'red', display: !datesValid(props.validDatesOfSale) ? 'block' : 'none' }}> * Required</small></div>
        <div style={{ width: '70%' }}>
          <TravelSalesDatesPicker
            dates={props.validDatesOfSale}
            disabled={props.isStayPay}
            forSaleDates
            contractingPeriod={props.contractingPeriod}
            onChange={(kp, value) => updateFieldValue(R.concat(['validDatesOfSale'], kp), value)}
          />
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' }}>
        <div style={{ width: '30%', position: 'relative', top: '-12px' }}> Travel dates<small style={{ color: 'red', display: !datesValid(props.validDatesOfTravel) ? 'block' : 'none' }}> * Required</small></div>
        <div style={{ width: '70%' }}>
          <TravelSalesDatesPicker
            dates={props.validDatesOfTravel}
            contractingPeriod={props.contractingPeriod}
            onChange={(kp, value) => updateFieldValue(R.concat(['validDatesOfTravel'], kp), value)}
          />
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' }}>
        <div style={{ width: '30%' }}>Offer detail</div>
        <textarea
          className="clickEditCell"
          style={{ border: '1px solid #00BCD4', textAlign: 'left', width: '70%', color: 'rgba(0, 0, 0, 0.64)' }}
          value={props.offerDetail || ''}
          onChange={({ target: { value } }) => updateFieldValue(['offerDetail'], value)}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' }}>
        <div style={{ width: '30%' }}>Special conditions</div>
        <textarea
          className="clickEditCell"
          style={{ border: '1px solid #00BCD4', textAlign: 'left', width: '70%', color: 'rgba(0, 0, 0, 0.64)' }}
          value={props.specialConditions || ''}
          onChange={({ target: { value } }) => updateFieldValue(['specialConditions'], value)}
        />
      </div>
      {
        props.isStayPay && (<div style={{ marginTop: '12px', padding: '0 0 8px 4px', clear: 'both' }}>
          <label><b>Which day(s) of the week does this offer apply to?</b><small style={{ color: 'red', display: R.isEmpty(props.daysOfWeek) ? 'inline-block' : 'none' }}> * Required</small></label>
          <br/>
          <DaysOfWeek
            daysOfWeek={props.daysOfWeek}
            updateDaysOfWeek={(checked, day, dayIndexInReducer) => {
              if (day === 'All') updateFieldValue(['daysOfWeek'], !checked ? [] : ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']);
              else {
                const daysOfWeek = checked ? R.uniq(R.append(day, props.daysOfWeek)) : R.remove(dayIndexInReducer, 1, props.daysOfWeek);
                updateFieldValue(['daysOfWeek'], daysOfWeek);
              }
            }}
          />
          <StayPays
            defaultYes
            staypayApplicable="yes"
            stayPayError={props.stayPayError}
            stayPays={props.stayPays}
            updateFieldValue={(key, val) => updateFieldValue([key], val)}
          />
        </div>)
      }
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' }}>
        <div style={{ width: '30%' }}>Rate details<small style={{ color: 'red', display: ratesNotValid ? 'block' : 'none' }}> * Required</small></div>
        <div style={{ width: '70%', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ padding: '8px 0', width: '35%' }}>
            {
              R.call(R.cond([
                [R.equals('freeOfCharge'), R.always('Free of charge')],
                  [R.equals('discount'), R.always('Discount')],
                  [R.T, R.always('Rate Amount')],
              ]), props.rate)
            }
          </div>
          <div style={{ width: '60%', display: props.rate === 'discount' ? 'flex' : 'none', justifyContent: 'space-between' }}>
            <div style={{ padding: '8px 0', width: '50%' }}>
              <Select
                name="rate"
                options={[
                  { value: 'percentage', label: 'Percentage' },
                  { value: 'flatRate', label: 'Flat fee' },
                ]}
                value={props.discountType}
                onChange={({ value }) => updateFieldValue(['discountType'], value)}
                placeholder="Discount Type"
                clearable={false}
                scrollMenuIntoView={false}
              />
            </div>
            <div style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
              <input
                type="number"
                onChange={({ target: { value } }) => updateFieldValue(['amount'], value)}
                value={props.amount || ''}
                style={{ border: '1px solid #ccc', height: '37px', paddingLeft: '8px', width: '100px' }}
              />
              <span style={{ lineHeight: '37px', fontSize: '24px' }}>{props.discountType === 'percentage' ? '%' : '$'}</span>
            </div>
          </div>
        </div>
      </div>
      {
        props.rate === 'rateAmount' && (
          <div>
            <TaxCurrencyCommissionForm
              hideCurrencyTax
              rateType={props.rateType}
              commissionPercentage={props.commissionPercentage}
              nettCommission={props.nettCommission}
              updateFunc={
                (field, value) => {
                  updateFieldValue([field], value);
                }
              }
            />
            <RateTable
              productType={props.productType}
              withEditableCell
              rateSet={{ rates: props.rates, nonStandardTemplateType: props.nonStandardTemplateType }}
              updateTableCell={updateTableCell}
              forOffer
              showHeader
            />
            {
              ratesTableNotValid(props) && <div style={{ color: 'red' }}>At least one rate detail is required.</div>
            }
          </div>)
      }
      <div style={{ marginTop: '12px', paddingLeft: '4px' }}>
        <label><b>Is this special offer combinable with other special offers?</b></label>
        <Toggle
          style={{ display: 'inline-block', width: '60px' }}
          toggled={props.allowCombination}
          onToggle={() => updateFieldValue(['allowCombination'], !props.allowCombination)}
        />
      </div>
    </div>
  );
};
SpecialOfferTableInEdit.propTypes = propTypes;
export default SpecialOfferTableInEdit;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/special-offer-tables/table-in-edit.jsx